import { IThuPhiTabCreateRequest } from "../../../models/request/thu-phi/IThuPhiTabCreateRequest";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { IThuPhiTabReducer } from "../../page-state-model/IThuPhiTabReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IThuPhiTabActionPayload<T> {
    tabId: string,
    data: T
}

export const eThuPhiTabActionsDefine = {
    ADD_NEW_TAB: undefined,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as IThuPhiTabReducer,
    CHANGEG_SELECTED_TAB: "",
    CREATE_THUPHI_START: {} as IThuPhiTabActionPayload<IThuPhiTabCreateRequest>,
    CREATE_THUPHI_SUCCCESS: {} as IThuPhiTabActionPayload<number>,
    CREATE_THUPHI_ERROR: {} as IThuPhiTabActionPayload<string>,

    LOAD_THU_PHI_START: {} as IThuPhiTabActionPayload<number>,
    LOAD_THU_PHI_SUCCESS: {} as IThuPhiTabActionPayload<sf_mucphaithu[]>,
    LOAD_THU_PHI_ERROR: {} as IThuPhiTabActionPayload<string>,
};
export const eThuPhiTabActionIds = generateActionTypeIds(eThuPhiTabActionsDefine, "THU_PHI_TAB");
export type IThuPhiTabActionTypes = IGenericActionType<typeof eThuPhiTabActionsDefine, "THU_PHI_TAB">;
